module.exports = __webpack_public_path__ + "static/media/pp-corn.ade99fcd.mp3";